import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Chip,
  InputAdornment,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { NumericFormatCurrency, NumericFormatUnit } from "../../AddProductForm/utils/formatters";

export default function TrechoPriceSection({
  formData,
  handleText,
  precoBase,
  precoFinal,
  economia,
  economiaPct,
  descontoValido,
}) {
  const { t } = useTranslation("products");
  const chipLabel =
    precoBase > 0
      ? economia > 0
        ? t("form.finalPriceWithSavings", {
            price: precoFinal.toFixed(2),
            savings: economia.toFixed(2),
            pct: economiaPct.toFixed(1),
          })
        : t("form.finalPriceLabel", { price: precoFinal.toFixed(2) })
      : t("trechoForm.priceReferenceEmpty");

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={t("trechoForm.priceTitle")}
        action={<Chip label={chipLabel} color="primary" variant="outlined" size="small" />}
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              label={t("trechoForm.referencePrice")}
              name="preco"
              value={formData.preco}
              onChange={handleText}
              fullWidth
              InputProps={{ inputComponent: NumericFormatCurrency }}
              helperText={t("trechoForm.referencePriceHelper")}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label={t("trechoForm.promoPrice")}
              name="preco_comdesconto"
              value={formData.preco_comdesconto}
              onChange={handleText}
              fullWidth
              InputProps={{ inputComponent: NumericFormatCurrency }}
              error={!descontoValido}
              helperText={
                !descontoValido
                  ? t("form.dealerPriceError")
                  : t("trechoForm.promoPriceHelper")
              }
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label={t("trechoForm.maxDiscount")}
              name="max_desconto"
              value={formData.max_desconto}
              onChange={handleText}
              fullWidth
              InputProps={{
                inputComponent: NumericFormatUnit,
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
              inputProps={{ decimalScale: 2 }}
              helperText={t("trechoForm.maxDiscountHelper")}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
